import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CognitoResponse } from '@core/interfaces';

@Component({
  selector: 'expiring-password-step',
  templateUrl: './expiring-password-step.component.html',
})
export class ExpiringPasswordStepComponent {
  @Input()
  public extraAuthInfo: CognitoResponse;

  @Input()
  public isLoading: boolean;

  @Output()
  public resetPassword: EventEmitter<void>;

  @Output()
  public authWithoutResetPassword: EventEmitter<void>;

  constructor() {
    this.resetPassword = new EventEmitter<void>();
    this.authWithoutResetPassword = new EventEmitter<void>();
  }
}
